import { render, staticRenderFns } from "./VscrollItem.vue?vue&type=template&id=9521a1ea&scoped=true&"
import script from "./VscrollItem.vue?vue&type=script&lang=js&"
export * from "./VscrollItem.vue?vue&type=script&lang=js&"
import style0 from "./VscrollItem.vue?vue&type=style&index=0&id=9521a1ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9521a1ea",
  null
  
)

export default component.exports